import type { Fold, Puzzle } from "../types.ts";

export function calculateStars(
  folds: Fold[],
  puzzle: Puzzle
): 1 | 2 | 3 {
  const optimal = puzzle.solution.length;
  const used = folds.length;

  if (used <= optimal) return 3;
  if (used <= optimal + 1) return 2;
  return 1;
}
